import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VeridionExportState } from './veridion-export.state';

// Feature selector
export const selectVeridionExportState = createFeatureSelector<VeridionExportState>('veridionExport');

// ============================================
// Validation Selectors
// ============================================
export const selectValidation = createSelector(
  selectVeridionExportState,
  (state: VeridionExportState) => state.validation
);

export const selectValidationLoading = createSelector(
  selectValidation,
  (validation) => validation.isLoading
);

export const selectValidationResult = createSelector(
  selectValidation,
  (validation) => validation.result
);

export const selectValidationError = createSelector(
  selectValidation,
  (validation) => validation.error
);

export const selectCanExport = createSelector(
  selectValidationResult,
  (result) => result?.can_export ?? false
);

export const selectCreditsRequired = createSelector(
  selectValidationResult,
  (result) => result?.credits_required ?? 0
);

export const selectCreditsAvailable = createSelector(
  selectValidationResult,
  (result) => result?.credits_available ?? 0
);

// ============================================
// Start Export Selectors
// ============================================
export const selectStartExport = createSelector(
  selectVeridionExportState,
  (state: VeridionExportState) => state.startExport
);

export const selectStartExportLoading = createSelector(
  selectStartExport,
  (startExport) => startExport.isLoading
);

export const selectStartExportResult = createSelector(
  selectStartExport,
  (startExport) => startExport.result
);

export const selectStartExportError = createSelector(
  selectStartExport,
  (startExport) => startExport.error
);

// ============================================
// Exports List Selectors
// ============================================
export const selectExportsState = createSelector(
  selectVeridionExportState,
  (state: VeridionExportState) => state.exports
);

export const selectExports = createSelector(
  selectExportsState,
  (exports) => exports.items
);

export const selectExportsLoading = createSelector(
  selectExportsState,
  (exports) => exports.isLoading
);

export const selectExportsError = createSelector(
  selectExportsState,
  (exports) => exports.error
);

export const selectExportsPagination = createSelector(
  selectExportsState,
  (exports) => exports.pagination
);

export const selectExportsCurrentPage = createSelector(
  selectExportsPagination,
  (pagination) => pagination.current_page
);

export const selectExportsTotalPages = createSelector(
  selectExportsPagination,
  (pagination) => pagination.last_page
);

export const selectExportsTotalCount = createSelector(
  selectExportsPagination,
  (pagination) => pagination.total
);

// ============================================
// Download Selectors
// ============================================
export const selectDownloadState = createSelector(
  selectVeridionExportState,
  (state: VeridionExportState) => state.download
);

export const selectDownloadingIds = createSelector(
  selectDownloadState,
  (download) => download.downloadingIds
);

export const selectIsDownloading = (exportId: number) => createSelector(
  selectDownloadingIds,
  (downloadingIds) => downloadingIds.includes(exportId)
);

export const selectDownloadError = createSelector(
  selectDownloadState,
  (download) => download.error
);
